import { type FeatureModule } from '@store/features/types';

export const rulesFeature: FeatureModule = {
  id: 'rules',
  name: 'Rules',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};

